import { render, staticRenderFns } from "./class-detail-page.html?vue&type=template&id=5668cde9&"
import script from "./class-detail-page.ts?vue&type=script&lang=ts&"
export * from "./class-detail-page.ts?vue&type=script&lang=ts&"
import style0 from "./class-detail-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports